import sprite from '../icons/sprite.svg?raw';

/** The app's Phosphor icons (Bold; Fill for the page you're on), from one sprite put in the page once. */
let added = false;
export function addSprite() {
  if (added) return;
  added = true;
  const holder = document.createElement('div');
  holder.innerHTML = sprite;
  const svg = holder.firstElementChild;
  if (svg) document.body.prepend(svg);
}

export type IconName = string;

export function Icon({ name, size, className = '' }: { name: IconName; size?: 'sm' | 'lg'; className?: string }) {
  return (
    <svg className={`i${size ? ` ${size}` : ''}${className ? ` ${className}` : ''}`} aria-hidden="true">
      <use href={`#i-${name}`} />
    </svg>
  );
}
